import { render, staticRenderFns } from "./ComixTeaser.vue?vue&type=template&id=4b73f5fe&scoped=true&"
import script from "./ComixTeaser.vue?vue&type=script&lang=js&"
export * from "./ComixTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ComixTeaser.vue?vue&type=style&index=0&id=4b73f5fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73f5fe",
  null
  
)

export default component.exports